import client from './client';

export interface MeResponse {
	id: number;
	email: string;
	name: string;
	picture_url?: string | null;
	created_at?: string;
	last_login_at?: string;
}

export interface GoogleLoginResponse {
	success: boolean;
	message?: string;
	token: string;
	user: {
		id: number;
		email: string;
		name: string;
		picture_url?: string | null;
	};
}

const authApi = {
	getMe: () => client.get<MeResponse>('/auth/me'),

	googleLogin: async (credential: string) => {
		const response = await client.post<GoogleLoginResponse>(
			'/auth/google-login',
			{ credential },
		);
		if (response.data?.success === false) {
			throw new Error(
				response.data.message ||
					'Google login failed',
			);
		}
		return response;
	},
};

export default authApi;
